import type {WalletOption} from 'src/v2/state/types';
import {isMobile} from 'src/utils/utils';

// mapped values come from lib/cryptocurrency/payins/core/constants/wallet_provider.rb
export const WALLET_PROVIDER_KEY_MAP: Record<string, string> = {
  MetaMask: 'metamask',
  Phantom: 'phantom',
  'Coinbase Wallet': 'coinbase_wallet',
  WalletConnect: 'wallet_connect',
};

const MOBILE_WALLET_PROVIDER_KEY_MAP = {
  MetaMask: 'dynamic-mobile-metamask',
  Phantom: 'dynamic-mobile-phantom',
  'Coinbase Wallet': 'dynamic-mobile-coinbase',
  WalletConnect: 'dynamic-mobile-walletconnect',
};

const ANDROID_WALLET_PROVIDER_KEY_MAP: Record<string, string> = {
  MetaMask: 'android-metamask',
  Phantom: 'android-phantom',
  'Coinbase Wallet': 'android-coinbase',
  WalletConnect: 'android-walletconnect',
};

export const getDisabledNetworksForProvider = (
  provider: string,
  disabledWalletProviders: string[],
): string[] => {
  const providerKey = WALLET_PROVIDER_KEY_MAP[provider];
  if (!providerKey) {
    return [];
  }
  return disabledWalletProviders
    .filter((entry) => entry.startsWith(`${providerKey}:`))
    .map((entry) => entry.split(':')[1]);
};

export const isWalletProviderDisabled = (
  walletOption: WalletOption,
  disabledProviders: string[],
  device?: string,
): boolean => {
  const isOnMobile = isMobile();

  if (
    disabledProviders.includes(WALLET_PROVIDER_KEY_MAP[walletOption.provider])
  ) {
    return true;
  }

  const mobileProviderKey =
    MOBILE_WALLET_PROVIDER_KEY_MAP[walletOption.provider];
  if (
    isOnMobile &&
    mobileProviderKey &&
    disabledProviders.includes(mobileProviderKey)
  ) {
    return true;
  }

  const androidProviderKey =
    ANDROID_WALLET_PROVIDER_KEY_MAP[walletOption.provider];
  if (
    device === 'android' &&
    androidProviderKey &&
    disabledProviders.includes(androidProviderKey)
  ) {
    return true;
  }

  return false;
};
